import { Redirect } from 'expo-router';

import { routes } from 'utils/routing';

export default function CartPaymentPage() {
  return <Redirect href={routes.cartCheckout} />;
}
